import React from "react";
import { useNavigate } from "react-router-dom";
import Illustration from "../../images/illustration/illustration-01.svg";

const ErrorPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="dark:bg-boxdark flex min-h-screen items-center justify-center bg-white">
      <div className="border-stroke shadow-default dark:border-strokedark dark:bg-boxdark mx-4 w-full max-w-[1500px] rounded-sm border bg-white px-5 py-10 sm:py-20">
        <div className="mx-auto max-w-[410px]">
          <img src={Illustration} alt="illustration" />

          <div className="mt-7.5 text-center">
            <h2 className="mb-3 text-2xl font-bold text-black dark:text-white">
              Страницата не може да бъде намерена
            </h2>
            <p className="font-medium">
              Страницата, която търсите, може да е била преместена, изтрита или
              да не съществува.
            </p>
            <button
              onClick={() => navigate("/login")}
              className="mt-7.5 bg-primary inline-flex items-center gap-2 rounded-md py-3 px-6 font-medium text-white hover:bg-opacity-90"
            >
              <i className="fa-solid fa-arrow-left"></i>
              <span>Обратно</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ErrorPage;
